/* The checkout's payment section and submit (prototype .coPay, .secure, .coSubmit), in the telify layer. */
@layer telify {
  .step {
    display: grid;
  }

  .secure {
    margin-top: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: var(--text-tertiary);
  }

  .submit {
    margin-top: 32px;
    padding-top: 26px;
    border-top: var(--line);
  }

  .decline {
    margin-bottom: 14px;
    font-size: 14.5px;
    color: var(--danger);
  }

  .pay {
    width: 100%;
  }

  .pay:disabled {
    background: transparent;
    color: var(--text-muted);
    border-color: var(--border-soft);
    cursor: default;
  }

  .confirming {
    display: grid;
    gap: 6px;
    font-size: 15px;
    color: var(--text-secondary);
  }

  .confirmTitle {
    font-size: 17px;
    font-weight: 600;
    color: var(--text-primary);
  }

  /* The state's notice (deposits, card paused, too close to pay, already paid), as the review's note. */
  .notice {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    font-size: 14.5px;
    color: var(--text-secondary);
  }

  .notice div {
    display: grid;
    gap: 2px;
  }

  .notice b {
    color: var(--text-primary);
  }
}
